import { render, staticRenderFns } from "./PracticeDetailCard.vue?vue&type=template&id=4d559a97&scoped=true"
import script from "./PracticeDetailCard.vue?vue&type=script&lang=js"
export * from "./PracticeDetailCard.vue?vue&type=script&lang=js"
import style0 from "./PracticeDetailCard.vue?vue&type=style&index=0&id=4d559a97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d559a97",
  null
  
)

export default component.exports